import type { FieldPolicy } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';

import { defaultKeyArgsFn } from './defaultKeyArgsFn';

const userActivitiesFieldPolicy = (): FieldPolicy => ({
  ...offsetLimitPagination(defaultKeyArgsFn()),
  merge(existing, incoming, { mergeObjects }) {
    return mergeObjects(existing ?? {}, { ...incoming, data: [...(existing?.data ?? []), ...incoming?.data] });
  },
});

export default userActivitiesFieldPolicy;
